module.exports = __webpack_public_path__ + "assets/img/btn-02b64376.png";